// Reusable documentation blocks about events and the settings of the event form.
// Body item types are described in ../README.md.
export default [
  {
    id: 'events.what',
    title: 'What is an event?',
    body: [
      { p: 'An event is a class of competition within a draft (for example, Open, Maiden, or Novice). Members nominate a horse and rider for an event, and once the draft is closed, draws are generated for each event.' }
    ]
  },
  {
    id: 'events.kinds.intro',
    title: 'Kinds of events',
    body: [
      { p: 'There are three kinds of events. The two checkboxes at the top of the form determine the kind:' },
      {
        ul: [
          'If neither is selected, it is a regular event.',
          'If **Combined** is selected, it is a combined event.',
          'If both **Combined** and **Conjunction** are selected, it is a conjunction event.'
        ]
      }
    ]
  },
  {
    id: 'events.kind.regular',
    title: 'Regular event',
    body: [
      { p: 'A single event with its own cost, restrictions, rounds, and draw. Members nominate directly into the event.' }
    ]
  },
  {
    id: 'events.kind.combined',
    title: 'Combined event',
    body: [
      {
        ul: [
          'Consists of two events (Event 1 and Event 2), for example, a combined Maiden/Novice event. Members have three options to nominate: Event 1, Event 2, or Event 1 & 2.',
          '**Cost with a discount** applies when a member enters both events.',
          'A combined event always has **2 rounds**. The first round is shared by both events, and each event has its own final.',
          'No Horse Required and Hidden event types cannot be combined.',
          'Once Combined is enabled, it cannot be undone.'
        ]
      }
    ]
  },
  {
    id: 'events.kind.conjunction',
    title: 'Conjunction event',
    body: [
      {
        ul: [
          'Similar to a combined event, but designed for an event that runs in conjunction with another event, for example, M4M run in conjunction with a Maiden. Members have two options to nominate: Event 1 or Event 1 & 2.',
          'Event 2 can only be entered together with Event 1.',
          'Once Conjunction is enabled, it cannot be undone.'
        ]
      }
    ]
  },
  {
    id: 'events.types',
    body: [
      { p: 'Choosing a Type fills the form with that event type\'s default settings. Depending on the type, these may include:' },
      {
        ul: [
          'Rounds (only for Open – N Round types)',
          'Rider minimum and maximum age',
          'Rider sex',
          'Maiden rider flag',
          'Horse age',
          'Horse class restrictions'
        ]
      },
      { p: 'You can change any of these settings afterwards. If you select a different event type, the defaults for the newly selected type are applied again.' },
      { p: 'Every type and the defaults it applies:' },
      { dynamic: 'event-types-table' }
    ]
  },
  {
    id: 'events.rounds',
    title: 'Rounds',
    body: [
      { p: 'Rounds is the total number of rounds in an event, including the final, and can be set from 1 to 5. The Open – 1 Round to Open – 5 Round types set the number of rounds automatically. For other event types, you choose the number of rounds manually. A combined event always has 2 rounds.' }
    ]
  },
  {
    id: 'events.judges',
    title: 'Number of Judges',
    body: [
      {
        ul: [
          'Number of Judges (1 to 3) determines how many judges score each run. Each judge enters a cutout, work, and course score.',
          'The run\'s cutout, work, and course scores, as well as its total score, are calculated by averaging the scores across all judges.',
          'The Judges field is used to assign judges to the event.'
        ]
      }
    ]
  },
  {
    id: 'events.noHorse',
    title: 'No Horse Required events',
    body: [
      {
        ul: [
          'The No Horse Required type is for events that do not involve riding. Members enter without a horse, and no draw is generated.',
          'Instead of Max Horses, it uses **Maximum Submissions Per Person**. Leave this blank or set it to 0 to allow unlimited submissions.',
          'Rounds, horse restrictions, Number of Judges, Judges, and Declared Prize Money are disabled for this event type.',
          'A No Horse Required event cannot be part of a combined event and does not appear on the Draws Dashboard.'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/docs/blocks/events.js